module.exports = __webpack_public_path__ + "img/doku.a46f4123.webp";